import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';
import { Footer } from './headerFooter';
import './custom.scss';

const PAGE_TITLE = 'Μεθοδολογία εκτιμήσεων — teachers-app.com';

const PredictMethodology = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = PAGE_TITLE;
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div id="root">
      <main className="main-container">
        <Container className="custom-container pt-3 pb-3">
          <div className="predict-methodology-content">
            <h2>Οδηγός ερμηνείας ποσοστών εκτίμησης πρόσληψης</h2>
            <p className="predict-methodology-updated">Τελευταία ενημέρωση: 8 Ιουνίου 2026</p>
            <p>
              Αυτός ο οδηγός εξηγεί τι σημαίνουν τα ποσοστά που εμφανίζονται όταν επιλέγετε
              περιοχές, δηλώνετε τη θέση σας στον πίνακα κατάταξης και υποβάλλετε τα φίλτρα
              στην σελίδα εκτιμήσεων.
            </p>

            <h3>Τι υπολογίζει η εφαρμογή;</h3>
            <p>
              Η εφαρμογή αναλύει <strong>ιστορικά δεδομένα</strong> προηγούμενων ετών (βάσει των
              θέσεων που τοποθετήθηκαν ανά περιοχή) και τα συγκρίνει με τη{' '}
              <strong>θέση κατάταξης</strong> που δηλώνετε. Η εκτίμηση αφορά την ημερομηνία
              πρόσληψης που επιλέγετε (φάση/ημέρα τοποθέτησης) και βασίζεται στα{' '}
              <strong>τελευταία 3 σχολικά έτη</strong>, με ίσο βάρος σε καθένα.
            </p>
            <p>
              Το αποτέλεσμα είναι <strong>ποσοστό ανά περιοχή</strong> (0–100%): η «δυναμική» της
              θέσης σας σε κάθε περιοχή που επιλέξατε, ξεχωριστά.
            </p>

            <h3>Ποσοστό ανά περιοχή</h3>
            <p>
              Κάθε περιοχή αξιολογείται <strong>αυτόνομα</strong> με κλίμακα από 0% έως 100%. Το
              ποσοστό δείχνει πόσο «ασφαλής» είναι η θέση σας για τη συγκεκριμένη περιοχή, με βάση
              το παρελθόν.
            </p>

            <h4>Πώς προκύπτει η ισχύς της θέσης</h4>
            <ul>
              <li>
                <strong>Συχνότητα:</strong> Πόσο συχνά η θέση σας ήταν εντός του εύρους
                προσλήψεων της περιοχής τα προηγούμενα έτη.
              </li>
              <li>
                <strong>Απόσταση:</strong> Πόσο «ψηλά» βρίσκεστε σε σχέση με την τελευταία θέση
                πρόσληψης (όσο πιο μπροστά, τόσο υψηλότερο το ποσοστό).
              </li>
            </ul>

            <div className="alert alert-warning py-2 px-3 small" role="note">
              <strong>Σημαντικό:</strong> Τα ποσοστά ανά περιοχή <strong>δεν αθροίζονται</strong>.
              Κάθε περιοχή μετράει ανεξάρτητα — μπορείτε π.χ. να έχετε 67% σε μία και 82% σε άλλη.
            </div>

            <h3>Κλίμακα αξιολόγησης</h3>
            <p>Στα αποτελέσματα εμφανίζεται και η κλίμακα αξιολόγησης δίπλα στο διάγραμμα:</p>
            <ul>
              <li>
                <strong>Υψηλό (80–100%):</strong> Ισχυρή θέση. Στο παρελθόν ήσασταν σχεδόν πάντα
                εντός εύρους και με σημαντικό προβάδισμα.
              </li>
              <li>
                <strong>Μεσαίο (40–70%):</strong> Μέτρια θέση. Η τοποθέτηση στην περιοχή αυτή
                εξαρτάται από τις μεταβολές του εκάστοτε έτους.
              </li>
              <li>
                <strong>Χαμηλό (0–30%):</strong> Αδύναμη θέση. Σπάνια ή ποτέ δεν καλύφθηκε η θέση
                σας ιστορικά στη συγκεκριμένη περιοχή.
              </li>
            </ul>

            <h3>Συχνές ερωτήσεις</h3>
            <dl className="predict-methodology-faq">
              <dt>Γιατί τα ποσοστά των περιοχών δεν έχουν άθροισμα 100%;</dt>
              <dd>
                Διότι δεν μοιράζεται μία ενιαία πιθανότητα. Η εφαρμογή εξετάζει κάθε περιοχή ως
                ξεχωριστή πιθανότητα τοποθέτησης.
              </dd>

              <dt>Τι σημαίνει ο όρος «εντός εύρους»;</dt>
              <dd>
                Σημαίνει ότι η θέση σας είναι <strong>μικρότερη ή ίση</strong> από τη θέση του
                τελευταίου ατόμου που προσλήφθηκε στην περιοχή αυτή κατά το έτος αναφοράς.
              </dd>

              <dt>Επηρεάζει η σειρά προτίμησης τα ποσοστά;</dt>
              <dd>
                <strong>Όχι.</strong> Η σειρά που δηλώνετε τις περιοχές δεν αλλάζει τους
                υπολογισμούς. Τα ποσοστά βασίζονται αποκλειστικά στη θέση σας και τα ιστορικά
                δεδομένα των περιοχών.
              </dd>

              <dt>Τι ρόλο παίζει η ημερομηνία πρόσληψης;</dt>
              <dd>
                Η επιλεγμένη ημερομηνία (μήνας/ημέρα) καθορίζει τη φάση πρόσληψης στην οποία
                αναφέρεται η εκτίμηση. Ο τίτλος των αποτελεσμάτων εμφανίζει μέχρι ποια ημερομηνία
                ισχύει η ανάλυση.
              </dd>
            </dl>

            <h3>Συμπληρωματικές πληροφορίες</h3>
            <p>Στους υπολογισμούς λαμβάνονται υπόψη τα φίλτρα που ορίζετε:</p>
            <ul>
              <li><strong>Ειδικότητα</strong></li>
              <li><strong>Θέση στον πίνακα κατάταξης</strong></li>
              <li><strong>Τύπος πίνακα</strong> (π.χ. Γενικής / Κύριος ειδικής / Επικουρικός)</li>
              <li>
                <strong>Ειδική αγωγή</strong> (όπου εφαρμόζεται για την ειδικότητά σας)
              </li>
              <li><strong>Περιοχές</strong> (έως 10)</li>
            </ul>
            <p>
              Κάτω από το διάγραμμα ποσοστών εμφανίζονται, όπου υπάρχουν δεδομένα, πίνακες
              ιστορικών προσλήψεων ανά έτος και περιοχή («Προσλήψεις ανά έτος και περιοχή»,
              «Τελευταίος διορισμός ανά έτος και περιοχή») για διαφάνεια και έλεγχο των
              αριθμών που χρησιμοποιήθηκαν.
            </p>

            <h3>Σύνοψη</h3>
            <div className="table-responsive">
              <table className="table table-bordered table-sm predict-methodology-table">
                <thead>
                  <tr>
                    <th>Δείκτης</th>
                    <th>Τι αντιπροσωπεύει</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Ποσοστό ανά περιοχή</strong></td>
                    <td>
                      Η <strong>δυναμική</strong> της θέσης σας αποκλειστικά για τη συγκεκριμένη
                      περιοχή (0–100%).
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="predict-methodology-disclaimer text-muted small mb-0">
              <strong>Disclaimer:</strong> Όλα τα δεδομένα αποτελούν προϊόν στατιστικής επεξεργασίας
              παρελθόντων ετών και προορίζονται για ενημερωτική χρήση. Δεν αποτελούν εγγύηση
              τοποθέτησης.
            </p>
          </div>

          <p className="mt-4 mb-0">
            <Link to="/predict" className="text-decoration-none">
              ← Επιστροφή στις Εκτιμήσεις πιθανοτήτων
            </Link>
          </p>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default PredictMethodology;
